import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useTelegramStore = defineStore('telegram', () => {
  const isTelegramMiniApp = ref(false)

  return {
    isTelegramMiniApp,
  }
})
